import React from 'react';
import { Link } from 'react-router-dom';
import cn from 'classnames';

import styles from './AnyEvent.module.postcss';

// Event-type crosslinks for discovery and SEO (voice bible §18 "what to
// keep"). Titles and lists are sentence case; each list is a short set of
// real event types, not a keyword dump.
const defaultEvents = [
  {
    title: 'Corporate catering',
    link: '/food-truck-catering/corporate-catering',
    text: 'Team lunches, in-office meal programs, employee and client appreciation, holiday parties, launches, retail events.',
    icon: '/static/images/badges/bubbles.svg'
  },
  {
    title: 'Private parties',
    link: '/food-truck-catering/private-parties',
    text: 'Birthdays, anniversaries, graduations, family reunions, neighborhood gatherings, backyard BBQs, pool parties.',
    icon: '/static/images/badges/mask.svg'
  },
  {
    title: 'Wedding catering',
    link: '/food-truck-catering/wedding-catering',
    text: 'Receptions, rehearsal dinners, showers, bachelor and bachelorette parties, welcome events, post-wedding brunches.',
    icon: '/static/images/badges/weddingrings.svg'
  },
  {
    title: 'Community events',
    link: '/food-truck-catering/community-events',
    text: 'Festivals, farmers markets, school events, fundraisers, church events, sporting events, concerts, street fairs.',
    icon: '/static/images/badges/stage.svg'
  },
  {
    title: 'Special occasions',
    link: '/food-truck-catering/special-occasions',
    text: 'Grand openings, product launches, open houses, charity events, trade shows, conferences, team building.',
    icon: '/static/images/badges/cake.svg'
  },
  {
    title: 'Recurring service',
    link: '/food-truck-catering/office-lunch',
    text: 'Office lunch rotations, construction sites, hospital staff meals, campus events, apartment communities, weekly routes.',
    icon: '/static/images/badges/party.svg'
  }
];

function Event({ title, text, icon, iconWidth, link }) {
  return (
    <div className='u-flex'>
      <div className={styles.DarkSection_Icon}>
        <img
          src={icon}
          alt={title}
          loading='lazy'
          fetchpriority='low'
          width='76'
          height='76'
          className={cn({
            [styles.iconSm]: iconWidth === 'sm',
            [styles.iconLg]: iconWidth === 'lg'
          })}
        />
      </div>
      <div>
        <h3 className='u-strong'>
          {link ? <Link to={link}>{title}</Link> : title}
        </h3>
        <p>{text}</p>
      </div>
    </div>
  );
}

function AnyEvent({ title, events }) {
  const eventsToRender = events || defaultEvents;

  return (
    <section className={cn('Section', styles.DarkSection)}>
      <h2 className='u-textCenter'>{ title || 'Parties, weddings, offices, festivals, fundraisers' }</h2>
      <div className={styles.DarkSection_Grid}>
        { eventsToRender.map((event) => (
          <Event
            key={event.title}
            title={event.title}
            text={event.text}
            icon={event.icon}
            iconWidth={event.width}
            link={event.link}
          />
        )) }
      </div>
    </section>
  );
}

export default AnyEvent;
